const footerNav = [
  {
    title: '快速导航',
    links: [
      { label: '编辑精选', href: '#picks' },
      { label: '题材速览', href: '#category' },
      { label: '热映片单', href: '#library' },
      { label: '本周热看榜', href: '#ranking' },
    ],
  },
  {
    title: '题材分类',
    links: [
      { label: '校园片', href: '#category' },
      { label: '初恋电影', href: '#category' },
      { label: '清纯少女', href: '#category' },
      { label: '小清新', href: '#category' },
      { label: '治愈系', href: '#category' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '影迷话题', href: '#talk' },
      { label: '观影指南', href: '#columns' },
      { label: '订阅片单', href: '#subscribe' },
      { label: '意见反馈', href: '#talk' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-950 text-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-[22px]" />
              </span>
              <span className="text-lg font-bold text-background-50">青苹果影院</span>
            </a>
            <p className="mt-4 text-sm text-background-300 leading-relaxed max-w-sm">
              青春电影大全，汇集校园片、初恋电影、清纯少女与小清新佳作。想重温学生时代的心动瞬间，就来这里找合口味的那一部。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['校园片', '初恋电影', '小清新', '治愈系'].map((t) => (
                <a
                  key={t}
                  href="#category"
                  className="text-xs text-background-200 border border-primary-700 px-2.5 py-1 rounded-full hover:bg-primary-900 transition-colors"
                >
                  {t}
                </a>
              ))}
            </div>
          </div>

          {footerNav.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h3 className="text-sm font-semibold text-background-50">{col.title}</h3>
              <ul className="mt-4 flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-300 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1">
            <h3 className="text-sm font-semibold text-background-50">社交</h3>
            <div className="mt-4 flex flex-col gap-3">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line'].map((icon) => (
                <a
                  key={icon}
                  href="#talk"
                  aria-label="社交媒体"
                  className="w-9 h-9 rounded-md bg-primary-900 text-background-200 flex items-center justify-center hover:bg-primary-800 transition-colors"
                >
                  <i className={`${icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-primary-900">
        <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-400">
          <span>© 2026 青苹果影院 · 青春电影大全　本站为影视资讯聚合演示站点</span>
          <div className="flex items-center gap-4">
            <a href="#top" className="hover:text-background-50 transition-colors">
              网站地图
            </a>
            <a href="#top" className="hover:text-background-50 transition-colors">
              隐私政策
            </a>
            <a href="#top" className="hover:text-background-50 transition-colors">
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}